<template>
  <div class="line p-6 bg-white w-ful">
    <div class="flex justify-end mb-4">
      <span @click="setFilter('year')" :class="{'text-blue-500': getCurrentFilter === 'year'}" class="block mr-6 hover:underline cursor-pointer hover:text-blue-500 font-light">Year</span>
      <span @click="setFilter('month')" :class="{'text-blue-500': getCurrentFilter === 'month'}" class="block mr-6 hover:underline cursor-pointer hover:text-blue-500 font-light">Month</span>
      <span @click="setFilter('week')" :class="{'text-blue-500': getCurrentFilter === 'week'}" class="block hover:underline cursor-pointer hover:text-blue-500 font-light">Week</span>
    </div>
    <GChart
      v-if="chartData.length > 1"
      class="mt-10"
      :type="'LineChart'"
      :data="chartData"
      :options="chartOptions"
    />
    <div v-else class="p-10 text-4xl text-red-500">
      No data available.
    </div>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts';

export default {
  name: 'LineSalesChart',
  components: {
    GChart,
  },
  computed: {
    getCurrentFilter() {
      return this.$store.state.AIGeospatial.line_chart_filters;
    },
    chartData() {
      return this.$store.getters['AIGeospatial/getLineChartData'];
    },
    chartOptions() {
      return {
        title: 'Company Performance',
        legend: { position: 'bottom' },
        vAxis: {
          baselineColor: 'none',
          gridlines: {
            color: 'none',
          },
        },
      };
    },
  },
  methods: {
    async setFilter(value) {
      this.$store.commit('AIGeospatial/setProperty', { property: 'line_chart_filters', payload: value });
      await this.$store.dispatch('AIGeospatial/fetchSales');
    },
  },
};
</script>

<style scoped>
  .line {
    flex: 0 1 40%;
  }
</style>
